<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/moneyBack_detail',title:'回款管理'},{title:'回款详情'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-pieceIn3">
                    <div class="h-pieceTitle2">
                        <h1>基本信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine h-mrb-38 money-back">
                            <el-form :inline="true" class="demo-ruleForm h-formbLine">
<!--                                <el-form-item label="银行名称" class="h-elformWrap-2">-->
<!--                                    <brselectlazy filterable category="BankCategory_agent" :v="this.result.receBank"-->
<!--                                                  disabled-->
<!--                                                  v-model="this.result.receBank"-->
<!--                                                  :clearable="true"-->
<!--                                    />-->
<!--                                </el-form-item>-->
                                <el-form-item label="汇款人" class="h-elformWrap-2">
                                    <el-input :value="this.result.remitterName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="汇款银行" class="h-elformWrap-2">
                                    <el-input :value="this.result.receBank" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="银行入账金额" class="h-elformWrap-2">
                                    <el-input :value="this.result.receAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="银行会计科目" class="h-elformWrap-2">
                                    <el-input :value="this.result.receBankNo" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="币种" class="h-elformWrap-2">
                                    <mdmselect category="YLCurrency" :v="this.result.receCurrency"
                                               v-model="this.result.receCurrency" disabled/>
                                </el-form-item>


                                <el-form-item label="凭证编码" class="h-elformWrap-2">
                                    <el-input :value="this.result.receCertNumber" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="销售组织" prop="saleGroupCode" class="h-elformWrap-2 ">
                                    <brselect category="xiaoshou_zuzhi" :v="this.result.saleGroupCode" readonly :showcode="true"
                                              clearable ></brselect>
                                </el-form-item>
                                <!--                                <el-form-item label="类型" class="h-elformWrap-2">-->
                                <!--                                    <el-input :value="this.res.receMark" readonly></el-input>-->
                                <!--                                </el-form-item>-->




<!--                                <el-form-item label="汇款人常驻国家" class="h-elformWrap-2" v-show="!this.callBackDomestic">-->
<!--                                    <brselectlazy filterable category="YLCountry_agent" :v="this.result.countryCode" disabled-->
<!--                                                  v-model="this.result.countryCode"-->
<!--                                                  :clearable="true"-->
<!--                                    />-->
<!--                                </el-form-item>-->
                            </el-form>
                        </div>
                    </div>
                </div>
<!--                <div class="h-pieceIn3" v-show="!this.callBackDomestic">-->
<!--                    <div class="h-pieceTitle2">-->
<!--                        <h1>贸易信息</h1>-->
<!--                    </div>-->
<!--                    <div class="h-pieceCon2">-->
<!--                        <div class="h-radio">-->
<!--                            <el-radio disabled v-model="radio" label="1">FOB/CIF/CFR</el-radio>-->
<!--                            <el-radio disabled v-model="radio" label="2">一般贸易/易贷贸易/来料加工</el-radio>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="h-pieceIn3" v-show="!this.callBackDomestic">
                    <div class="h-pieceTitle2">
                        <h1>回款信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine h-mrb-38 money-back">
                            <el-form :inline="true" class="demo-ruleForm h-formbLine">
                                <el-form-item label="经销商编码" class="h-elformWrap-2">
                                    <el-input :value="this.result.customerCode" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="经销商名称" class="h-elformWrap-2">
                                    <el-input :value="this.result.customerName" readonly></el-input>
                                </el-form-item>

                                <el-form-item label="认领金额" class="h-elformWrap-2">
                                    <el-input :value="this.result.enterAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="手续费" class="h-elformWrap-2">
                                    <el-input :value="this.result.commission" readonly></el-input>
                                </el-form-item>

                                <el-form-item label="汇款人常驻国家" class="h-elformWrap-2" readonly prop="countryCode">
                                    <brselectlazy filterable category="YLCountry_agent" :v="this.result.countryCode"
                                                  :clearable="true"
                                                  :showcode="true"
                                                  disabled
                                    />
                                </el-form-item>
                                <el-form-item label="交易附言" class="h-elformWrap-2 shouxufei" prop="tradeWay">
                                    <brselectlazy filterable category="jiaoyifuyan" :v="this.result.tradeWay"
                                                  :clearable="true"
                                                  :showcode="true"
                                                  disabled
                                    />
                                </el-form-item>
                                <el-form-item label="认领余额" class="h-elformWrap-2">
                                    <el-input :value="this.result.balanceAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="认领人" class="h-elformWrap-2">
                                    <el-input :value="this.result.claimName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="认领人编码" class="h-elformWrap-2">
                                    <el-input :value="this.result.claimCode" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="备注" class="h-elformWrap-2">
                                    <el-input :value="this.result.remark" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="合同、发票、第三方汇款委托证明等资料" class="h-elformWrap-1 extraItem"
                                              style="width:100%!important;">
                                    <brupload
                                            :refid="refid"
                                            reftype="回款认领-第三方回款委托证明"
                                    >
                                    </brupload>
                                </el-form-item>

                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn3">
                    <div class="h-pieceTitle2">
                        <h1>关联订单列表</h1>
                    </div>
                    <div class="h-table h-mrt20">
                        <el-table
                                ref="multipleTable"
                                :data="tableData2"
                                stripe
                                style="width: 100%"
                        >
                            <el-table-column
                                    fixed
                                    type="index"
                                    label="#"
                                    width="40">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="订单编号"
                                    width="120">

                            </el-table-column>
                            <el-table-column
                                    prop="add2"
                                    label="SAP订单编号"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="cdate"
                                    label="下单时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="add5"
                                    label="开票时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="orderPrice"
                                    label="订单总额(元)"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="currencyCode"
                                    label="币种"
                                    width="80">
                            </el-table-column>

                            <el-table-column
                                    prop="claimMoney"
                                    label="认领金额(元)"
                            >
                            </el-table-column>
                            <el-table-column
                                    v-if="this.result.tradeWay== 2"
                                    label="报关单">
                                <template slot-scope="scope">
                                    <brupload
                                            style="margin-top: 0.1rem;"
                                            :showtime="false"
                                            :refid="scope.row.sapCode"
                                            reftype="WXFJ_BGD"
                                            />
                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="h-pieceIn3" v-if="this.tableData3 != ''">
                    <div class="h-pieceTitle2">
                        <h1>凭证列表</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine h-mrb-38 money-back">
                            <el-form :inline="true" class="demo-ruleForm h-formbLine">

                                <el-form-item label="凭证抬头" class="h-elformWrap-2">
                                    <el-input v-if="this.isApprove && this.taskstatus != 1" v-model="tableData3.bktxt" :value="tableData3.bktxt"></el-input>
                                    <el-input v-else :value="tableData3.bktxt" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="公司代码" class="h-elformWrap-2">
                                    <el-input :value="tableData3.bukrs" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="凭证日期" class="h-elformWrap-2">
                                    <el-date-picker v-if="this.isApprove && this.taskstatus != 1"
                                            :value="tableData3.BLDAT"
                                            v-model="tableData3.bldat"
                                            type="date"
                                            value-format="yyyy-MM-dd hh:mm:ss"
                                            placeholder="选择日期时间">
                                    </el-date-picker>
                                    <el-input v-else :value="tableData3.BLDAT" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="过账日期" class="h-elformWrap-2">
                                    <el-date-picker v-if="this.isApprove && this.taskstatus != 1"
                                                    :value="tableData3.BUDAT"
                                                    v-model="tableData3.budat"
                                                    type="date"
                                                    value-format="yyyy-MM-dd hh:mm:ss"
                                                    placeholder="选择日期时间">
                                    </el-date-picker>
                                    <el-input v-else :value="tableData3.BUDAT" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="凭证类型" class="h-elformWrap-2">
                                    <brselectlazy v-if="this.isApprove && this.taskstatus != 1"  category="hk_pingzhengleixing" :v="tableData3.blart" v-model="tableData3.blart"
                                                  :clearable="true"
                                                  :showcode="true"
                                    />
                                    <el-input v-else :value="tableData3.blart" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="货币码" class="h-elformWrap-2">
                                    <el-input :value="tableData3.waers" readonly></el-input>
                                </el-form-item>
                                <el-form-item  v-if="this.isApprove && this.taskstatus != 1 " label="原因代码" class="h-elformWrap-2 shouxufei">

                                    <brselectlazy v-if="this.isApprove && this.taskstatus != 1"  @change="goBackSgtxt"  category="hk_yuanyindaima" :v="tableData3.list[0].rstgr"  v-model="tableData3.list[0].rstgr"
                                                  :clearable="true"
                                                  :showcode="true"
                                    />
                                </el-form-item>
                                <el-form-item  v-if="this.isApprove && this.taskstatus != 1 && tableData3.list.length > 2" label="手续费类型" class="h-elformWrap-2 shouxufei">
                                    <el-select v-model="tableData3.list[2].hkont_BX" @change="goBackSgtxt" placeholder="请选择">
                                        <el-option label="正常汇款手续费" value="6603040000"></el-option>
                                        <el-option label="电汇收款" value="6603050000"></el-option>
                                        <el-option label="信用证专用扣费" value="6603060000"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="文本" v-if="this.isApprove && this.taskstatus != 1 && tableData3.list.length > 2 &&  (tableData3.list[2].hkont_BX == '6603060000' || tableData3.list[2].hkont_BX == '6603050000')" class="h-elformWrap-2">
                                    <el-input placeholder="请填写" v-model="sgtxt" @change="changeSgtxt" prop="sgtxt"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="h-table h-mrt20">
                        <el-table
                                ref="multipleTable"
                                :data="tableData3.list"
                                stripe
                                style="width: 100%"
                                @cell-click="tabClick"
                        >
                            <el-table-column
                                    prop="buzei"
                                    label="行项目数"
                                    width="50"
                            >

                            </el-table-column>
                            <el-table-column
                                    prop="kostl"
                                    label="成本中心"
                                    width="130"
                            >
                                <template slot-scope="scope">
                                    <span v-if=" scope.row.id === tabClickIndex && tabClickLabel === '成本中心'">
                                      <el-input v-model="scope.row.kostl" maxlength="300" placeholder="请输入成本中心" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.kostl }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="acc_TYPE"
                                    label="科目类型"
                                    width="50"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '科目类型'">
                                      <el-input v-model="scope.row.acc_TYPE" maxlength="1" placeholder="请输入科目类型" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.acc_TYPE }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="shkzg"
                                    label="借方/贷方标识"
                                    width="90"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="bschl"
                                    label="记帐代码"
                                    width="50"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '记帐代码'">
                                      <el-input v-model="scope.row.bschl" maxlength="2" placeholder="请输入记帐代码" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.bschl }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="rstgr"
                                    label="原因代码"
                                    width="80"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '原因代码'">
                                      <el-input v-model="scope.row.rstgr" maxlength="3" placeholder="请输入原因代码" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.rstgr }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="hkont"
                                    label="供应商"
                                    width="100"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="hkont_BX"
                                    label="总账科目"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '总账科目'">
                                      <el-input v-model="scope.row.hkont_BX" maxlength="20" placeholder="请输入总账科目" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.hkont_BX }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="wrbtr"
                                    label="凭证货币金额"
                                    width="120"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '凭证货币金额'">
                                      <el-input v-model="scope.row.wrbtr" maxlength="15" placeholder="请输入凭证货币金额" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.wrbtr }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="sgtxt"
                                    label="项目文本"
                                    :show-overflow-tooltip="true"
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.id === tabClickIndex && tabClickLabel === '项目文本'">
                                      <el-input v-model="scope.row.sgtxt" maxlength="1024" placeholder="请输入项目文本" size="mini" v-focus @blur="inputBlur"/>
                                    </span>
                                    <span v-else>{{ scope.row.sgtxt }}</span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>

                </div>
            </div>
            <div class="h-table h-mrt30    moneyBack" v-if="this.isApprove && this.taskstatus != 1">
                        <div class="h-pieceTitle2 hang">
                            <h1 class="h1" style="margin-left:20px">审批意见</h1>
                            <el-form
                                :inline="true"
                                class="demo-ruleForm h-formbLine"
                                :model="UserReceForeignVO.userReceForeign"
                                ref="formLabelAlign1"
                                :rules="rules">
                                <div class="h-txtLeft">
                                    <el-form-item label="审批意见" class="h-elformWrapz-1"  style="margin-top:20px;" prop="yjMsg">
                                        <el-input v-model="UserReceForeignVO.userReceForeign.yjMsg" placeholder="审批意见" style="width:400px" :disabled="taskstatus==1"></el-input>
                                    </el-form-item>
                                    <br>
                                </div>
                            </el-form>
                        </div>
                    </div>
                    <viewhistory
                        :visible.sync="showhistory"
                        v-if="showhistory"
                        :id="instid"
                    />
            <div class="h-txtCenter h-mrt60">
                <el-button class="el-button h-btn h-bBtn el-button--default" v-if="this.$route.query.backurl != undefined" :class="[this.isApprove||(this.isApprove && this.taskstatus != 1)?'h-bgwhite':'h-bgblueQ2']" @click="queren">返回</el-button>
                <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"  v-if="this.isApprove && this.taskstatus != 1"
                           @click="exec('formLabelAlign1')">驳回
                </el-button>
                <el-button class="el-button h-btn h-bBtn h-bggreen el-button--defaul" @click="pass('formLabelAlign1')" v-if="this.isApprove && this.taskstatus != 1">
                    通过
                </el-button>
                <el-button class="el-button h-btn el-button--defaul" @click="viewpress" v-if="this.isApprove">
                    审批跟踪
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";

    export default {
        name: 'leftMenu',
        data() {
            return {
                tabClickIndex: null, // 点击的单元格
                tabClickLabel: '', // 当前点击的列名
                belnr: '',
                taskstatus: '',
                rules: {
                    yjMsg:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                },
                instid: '',
                showhistory: false,
                taskid: '',
                UserReceForeignVO: {
                    orderNoList: [],
                    userReceForeign: {
                    },
                    userReceForeignVoucher: {
                        list:[]
                    },
                },
                isApprove: false,
                refid: '',
                reftype: '回款认领-上传凭证',
                q: {
                    foreignId: null,
                },
                callBackDomestic: false,
                result: {},
                res: {
                    receMark: null
                },
                oldsgtxt:'',
                sgtxt:'',
                //表单
                formInline: {
                    customerName: '',
                    date1: '',
                    date2: '',
                    date3: '',
                    type: ''
                },
                //r单选
                radio: '1',
                //表格
                tableData2: [],
                tableData3: [],
                backurl:""
            }
        },
        directives: {
            focus: {
                inserted: function (el) {
                    el.querySelector('input').focus()
                }
            }
        },
        created() {
            if (this.$route.query.id == undefined) {
                this.refid = this.$route.query.ywid;
                this.taskid = this.$route.query.taskid;
                this.instid = this.$route.query.instid;
                this.taskstatus = this.$route.query.taskstatus;
                this.isApprove = true;
            } else {
                this.refid = this.$route.query.id;
                this.belnr = this.$route.query.belnr;
                this.isApprove = false;
            }
            this.backurl = "/"+this.$route.query.backurl;
            console.log(this.isApprove, '是否是审批进入')
        },
        methods: {
            // 添加明细原因 row 当前行 column 当前列
            tabClick(row, column, cell, event) {
                if(this.isApprove && this.taskstatus != 1){
                    this.tabClickIndex = row.id
                    this.tabClickLabel = column.label
                }

            },
            // 失去焦点初始化
            inputBlur(row, event, column) {
                this.tabClickIndex = null
                this.tabClickLabel = ''
            },
            goBackSgtxt(){

                if(this.tableData3.list[2].hkont_BX == '6603060000'){
                    this.sgtxt = '信用证费用';
                    this.tableData3.list[2].sgtxt = this.sgtxt;
                }else{
                    this.tableData3.list[2].sgtxt =this.oldsgtxt+"";
                    this.sgtxt = '';
                }

            },
            changeSgtxt(){
                this.tableData3.list[2].sgtxt = this.sgtxt;
            },
            viewpress() {
                this.showhistory = true;
            },
            //审核驳回
            exec(v) {
                this.$refs[v].validate((valid) => {
                    if (valid) {
                        //组装数据
                        for (var i = 0; i < this.tableData2.length; i++) {
                            this.UserReceForeignVO.orderNoList.push(this.tableData2[i]);
                        }
                        this.result.yjMsg = this.UserReceForeignVO.userReceForeign.yjMsg;
                        this.UserReceForeignVO.userReceForeign = this.result;
                        this.UserReceForeignVO.userReceForeign.taskid = this.taskid;
                        this.UserReceForeignVO.userReceForeign.isPassed = 2;
                        // this.UserReceForeignVO.userReceForeign.yjMsg = '驳回！';
                        //请求后台
                        console.log(this.UserReceForeignVO, '提交时数据')
                        ss.moneyBackforeignService.claimApprove(this.UserReceForeignVO).then(response => {
                            console.log(response, '审核通过返回结果')
                            if (response.f) {
                                this.$msg.alerts("提交成功！", () => {
                                    //刷新右上角的代办个数
                                    this.$store.dispatch("searchTasktotal")
                                    //跳转回系统的代办列表
                                    this.$router.push({path: '/personal/dealCenter'})
                                })
                            }
                        })
                    }else {
                        return false;
                    }
                });
            },
            //通过审核
            pass(v) {
                // this.$refs[v].validate((valid) => {
                //     if (valid) {
                        //组装数据
                        for (var i = 0; i < this.tableData2.length; i++)
                        {
                            this.UserReceForeignVO.orderNoList.push(this.tableData2[i]);
                        }
                        this.result.yjMsg = this.UserReceForeignVO.userReceForeign.yjMsg;
                        this.UserReceForeignVO.userReceForeign = this.result;
                        this.UserReceForeignVO.userReceForeign.taskid = this.taskid;
                        this.UserReceForeignVO.userReceForeign.isPassed = 1;

                        // if(this.tableData3.list.length>2){
                        //     this.UserReceForeignVO.userReceForeignVoucher.list.push(this.tableData3.list[2]);
                        // }
                        this.UserReceForeignVO.userReceForeignVoucher = this.tableData3;
                        // this.UserReceForeignVO.userReceForeign.yjMsg = '通过！';
                        //请求后台
                        ss.moneyBackforeignService.claimApprove(this.UserReceForeignVO).then(response => {
                            console.log(response, '审核通过返回结果')
                            if (response.f) {
                                this.$msg.alerts("提交成功！", () => {
                                    //刷新右上角的代办个数
                                    this.$store.dispatch("searchTasktotal")
                                    //跳转回系统的代办列表
                                    this.$router.push({path: '/personal/dealCenter'})
                                })
                            }
                        })
                //     }else {
                //         return false;
                //     }
                // });

            },
            queryForeign() {
                let id = "";
                if (this.$route.query.id == undefined) {
                    id = this.$route.query.ywid;
                }else{
                    id = this.$route.query.id;
                }
                ss.moneyBackforeignService.queryForeign(id).then(response => {
                    this.result = response.obj;
                    this.q.foreignId = this.result.id;
                    if(this.result.isBandOrders == '1'){
                        this.q.foreignId = this.result.id;
                        ss.moneyBackClaimService.getClaimedApproveOrders(this.q).then(response => {
                            console.log(response, '订单列表1')
                            this.tableData2 = response;
                        })

                    }else{
                        ss.moneyBackClaimService.getClaimedOrders(this.q).then(response => {
                            console.log(response, '订单列表2')
                            this.tableData2 = response;
                        })
                    }
                    ss.moneyBackClaimService.selectVoucher(this.q.foreignId).then(response => {
                        console.log(response, '凭证列表')
                        this.tableData3 = response;
                        if(this.tableData3.list.length>2){
                            this.oldsgtxt = this.tableData3.list[2].sgtxt+"";
                        }

                    })
                })

            },
            queren() {
				this.$router.back();

            },
            quxiao() {
                if (this.callBackDomestic) {
                    this.$router.push({path: "/moneyBack_domestic_list"});
                } else {
                    this.$router.push({path: this.backurl});
                }
            },
        },
        mounted() {
            this.queryForeign()
        },
    }
</script>

<style>
    .Button {
        margin-left: 30rem;
    }

    .money-back .h-formbLine .el-form-item__label {
        width: 36%;
        text-align: right;
    }

    .money-back .h-formbLine .el-form-item__content {
        width: 64%;
    }

    .money-back .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .money-back .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .money-back .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .money-back .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
    .moneyBack .h-formbLine .el-form-item__label{
        width: 20%
    }
    .el-input__inner {
        padding : 5px 0px 5px 0px;
    }
</style>
<style scoped>
    .bbbb {
        padding-top: 5px;

    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }


</style>

